"use strict";function datetimepicker$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.datetimepicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.datetimepicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.datetimepicker$=datetimepicker$,exports.default=datetimepicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/datetimepicker.js
// module id = 1005
// module chunks = 106